import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack } from '@mui/material'
import { morphForWords } from 'components/shared/processes'
import useLamenessInfoForChart from 'hook/query/useLamenessInfoForChart'
import moment from 'moment'
import { useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import TooltipHover from 'ui/TooltipHover'
import { ExpiredLicense } from 'ui/expired-license/ExpiredLicense'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import LinearChart from '../shared/LinearChart'
import LinearChartLegend from '../shared/LinearChartLegend'

interface LamenessInfoProps {
	groupIds?: string
}

const LamenessInfo = ({ groupIds }: LamenessInfoProps) => {
	const [dateRange, setDateRange] = useState({
		startDate: moment().startOf('day').valueOf(),
		endDate: moment().endOf('day').valueOf(),
	})
	const { dotsInfo, isLoading, error } = useLamenessInfoForChart(
		dateRange,
		groupIds,
	)
	const totalCattle = dotsInfo.reduce((acc, el) => {
		return acc + el.segmentValue
	}, 0)
	const onePointScore = dotsInfo.find(el => el.score === 1).segmentValue
	const totalCattlesWithoutOneScore = totalCattle - onePointScore
	const morpWord = morphForWords(totalCattlesWithoutOneScore, [
		'голова',
		'головы',
		'голов',
	])

	return (
		<CardStandart sx={{ padding: '24px' }}>
			{isLoading ? (
				<Skeleton height={'24px'} />
			) : (
				<>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							alignItems: 'center',
							gap: '4px',
							marginBottom: '8px',
						}}
					>
						<TypographySecondary>
							{`Всего хромых ${totalCattlesWithoutOneScore.toLocaleString()} ${morpWord}`}
						</TypographySecondary>
						<TooltipHover
							title='Данные отображаются за сегодня и обновляются в течение дня'
							placement='top-end'
							disableHoverBackground
							maxWidth='240px'
						>
							<Box
								sx={{
									display: 'flex',
									color: COLORS.icon,
									cursor: 'pointer',
									'&:hover': { color: COLORS.main },
								}}
							>
								<InfoOutlinedIcon sx={{ fontSize: 18, color: 'inherit' }} />
							</Box>
						</TooltipHover>
					</Box>
					<LinearChart dotsInfo={dotsInfo} totalCount={totalCattle} />
				</>
			)}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginTop: '24px',
					flexWrap: 'wrap',
				}}
			>
				{isLoading ? (
					Array.from(Array(5)).map((_, index) => (
						<Skeleton key={index} height={'47px'} width={'150px'} />
					))
				) : error?.response.status === 450 ? (
					<Stack sx={{ flex: 1 }}>
						<ExpiredLicense />
					</Stack>
				) : (
					dotsInfo.map(el => (
						<LinearChartLegend
							key={el.score}
							score={el.score}
							label={el.label}
							totalCattlesByCategory={el.segmentValue}
							totalCattles={totalCattle}
						/>
					))
				)}
			</Box>
		</CardStandart>
	)
}

export default LamenessInfo
